export const API_STRIPE_ROUTES = Object.freeze({
    PAYMENT_INTENT_INVOICE: '/stripe/payment-intent-invoice',
});
